// FILE: src/components/admin/SubNav.jsx
// Links between the pages of one area (a student's sections, the exports)
// drawn as tabs, like the profile pages (WP-8). Real links in a <nav> with
// aria-current="page", so each section has its own URL and Back works; on a
// phone the row scrolls sideways inside itself, starting at the current page.
import React, { useEffect, useRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box } from "@mui/material";

export default function SubNav({ label, items, current }) {
  const navRef = useRef(null);
  // Keep the current section in view when the row is wider than the screen.
  useEffect(() => {
    const nav = navRef.current;
    const active = nav?.querySelector('[aria-current="page"]');
    if (!nav || !active || nav.scrollWidth <= nav.clientWidth) return;
    nav.scrollLeft = Math.max(0, active.offsetLeft - 16);
  }, [current]);

  return (
    <Box
      component="nav"
      ref={navRef}
      aria-label={label}
      sx={{ borderBottom: 1, borderColor: "divider", mb: 3, overflowX: "auto", position: "relative" }}
    >
      <Box component="ul" sx={{ display: "flex", gap: 0.5, listStyle: "none", m: 0, p: 0, minWidth: "max-content" }}>
        {items.map((s) => {
          const active = s.path === current;
          return (
            <li key={s.path}>
              <Box
                component={RouterLink}
                to={s.path}
                aria-current={active ? "page" : undefined}
                sx={{
                  display: "block",
                  px: 2,
                  py: 1.5,
                  minHeight: 48,
                  fontWeight: active ? 700 : 600,
                  color: active ? "primary.main" : "text.secondary",
                  textDecoration: "none",
                  borderBottom: "3px solid",
                  borderColor: active ? "primary.main" : "transparent",
                  borderRadius: "8px 8px 0 0",
                  "&:hover": { color: "text.primary", bgcolor: "action.hover" }
                }}
              >
                {s.label}
              </Box>
            </li>
          );
        })}
      </Box>
    </Box>
  );
}
